export default "__VITE_ASSET__Can6lLek__"